// Common
import { ReactElement, useState, useEffect, useReducer, useCallback } from 'react'

// Interface
import { IProps } from '../interface'

// Reducer
import infoReducer from '../reducers/info'

// Components
import Row from 'shared-components/row'
import { Checkbox } from '@material-ui/core'
import Col from 'shared-components/col'
import Input from 'shared-components/input'
import Typography from 'shared-components/typography'
import Buttons from 'components/common/Buttons'
import Errors from '../common/Errors'

// Variables
import { validEmail, validSpace, validPhone } from '../../variables'

export default function Info(props: IProps): ReactElement {
	const [error, setError] = useState('')
	const [data, setData] = useState({
		name: '',
		surname: '',
		email: '',
		phone: '',
	})
	const [disable, setDisable] = useState(false)
	const [consent, setConsent] = useState(false)
	const [state, dispatch] = useReducer(infoReducer, {
		name: data.name, surname: data.surname, email: data.email, phone: data.phone, consent: consent,
	})

	useEffect(() => {
		dispatch({type:'name', name: data.name})
		dispatch({type:'surname', surname: data.surname})
		dispatch({type:'email', email: data.email})
		dispatch({type: 'phone', phone: data.phone})
		dispatch({type: 'consent', consent: consent})
	}, [dispatch, data, consent])

	const validate = useCallback(value => {
		if (!value || !validSpace.test(value) || value === undefined){
			return false
		}else{
			setError('')
			setDisable(false)
			return true
		}
	}, [])

	useEffect(() => {
		const getInfo = JSON.parse(sessionStorage.getItem('info') || '{}')
		if(getInfo !== {}){
			setData({
				name: getInfo.name,
				surname: getInfo.surname,
				email: getInfo.email,
				phone: getInfo.phone,
			})
		}
		if (!validate(getInfo.name) ||
				!validate(getInfo.surname) ||
				!validate(getInfo.email) ||
				!validate(getInfo.phone)){
			setError('')
			setDisable(false)
		}
	}, [state.name, state.phone, state.email, state.surname, consent])

	useEffect(() => {
		sessionStorage.setItem('consent', JSON.stringify(consent))
		sessionStorage.setItem('info', JSON.stringify(data))
	}, [data, consent])

	const handleInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		setData({
			...data,
			[event.target.name]: event.target.value,
		})
	 	sessionStorage.setItem('info', JSON.stringify(data))
	}, [data])

	const handleCheckboxChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		setConsent(event.target.checked)
		sessionStorage.setItem('consent', JSON.stringify(consent))
	}, [consent])

	const onClick = useCallback(() => {
		const getInfo = JSON.parse(sessionStorage.getItem('info') || '{}')
		if(!consent){
			setError('You shoud agree with all Terms and Private Police')
			setDisable(true)
		} else if(!validEmail.test(getInfo.email)){
			setError('Enter correct email')
			setDisable(true)
		} else if(!validPhone.test(getInfo.phone)){
			setError('Enter correct phone')
			setDisable(true)
		} else if(!validate(getInfo.name) || !validate(getInfo.surname) || !validate(getInfo.email) || !validate(getInfo.phone)||
		((!validPhone.test(getInfo.phone)) || (!validEmail.test(getInfo.email)) || !consent)){
			setError('Fields should not be empty')
			setDisable(true)
		}else{
			props.onClickNext()
		}
	}, [state.name, state.phone, state.email, state.surname, consent])

	return (
		<>
			<Col>
				<>
					{error && <Errors error={error} />}
					<Input
						label="Name"
						placeholder="Enter your name"
						onChange={handleInputChange}
						name='name'
						value={data.name}
					/>
					<Input
						label="Surname"
						placeholder="Enter your surname"
						onChange={handleInputChange}
						name='surname'
						value={data.surname}
					/>
					<Input
						label="Email"
						placeholder="Enter your email"
						onChange={handleInputChange}
						name='email'
						value={data.email}
					/>
					<Input
						label="Phone Number"
						placeholder="+XXXXXXXXXXXX"
						onChange={handleInputChange}
						name='phone'
						value={data.phone}
					/>
					<Row>
						<>
							<Checkbox name='consent' checked={consent} onChange={handleCheckboxChange}/>
							<Typography style={{ fontSize: '12px', lineHeight: '20px' }} >
								<>
									I agree with all{' '}
									<a
										className="updates-text-link"
										href="https://landing-35.web.app/terms"
										target="_blank"
										rel="noopener noreferrer"
										style={{ color: '#8A54E8' }}
									>
										Terms and Private Police
									</a>
								</>
							</Typography>
						</>
					</Row>
				</>
			</Col>
			<Buttons
				goBack={props.goBack}
				goNext={onClick}
				disable={disable}
			/>
		</>
	)
}
